import { ReduxStore } from 'store/types';

function uploadIsLoading(state: ReduxStore): boolean {
  return state.image.upload.config.isLoading;
}

export default uploadIsLoading;
